/**
 * Module registry so Conversation Assistant (which owns chat-context bridge wiring)
 * can publish a canonical context provider for Enterprise HER without React tree coupling.
 */
export type RovoChatContextProvider = () => Promise<Record<string, unknown>>;

let registeredProvider: RovoChatContextProvider | null = null;

export function setRovoChatContextProvider(provider: RovoChatContextProvider | null): void {
	registeredProvider = provider;
}

export function getRovoChatContextProvider(): RovoChatContextProvider | null {
	return registeredProvider;
}
